import moment from "moment";
import api from "./Api";
import { handleApiError } from "../utils/apiUtils";

const DashBoard = process.env.REACT_APP_DASHBOARD_URL || "";
const DashboardAPI = api(DashBoard);

export interface ApiResponse<T> {
  result: T;
  isSuccess: boolean;
  message: string;
  statusCode: number;
}

export interface AppointmentSummary {
  caseAppointmentId: number;
  appointmentType: string;
  appointmentValues_Scheduled: number;
  appointmentValues_Completed: number;
  appointmentValues_Cancelled: number;
  appointmentValues_OnTime?: number;
}

export const getEditorRecentActivity = async (limit: any): Promise<any> => {
  try {
    const response = await DashboardAPI.get<ApiResponse<any>>(
      `/api/editor/dashboard/recent-activity?limit=${limit}`,
    );

    return response.data?.result;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const getEditorRushNotesSummary = async (limit: any): Promise<any> => {
  try {
    const response = await DashboardAPI.get<ApiResponse<any>>(
      `/api/editor/dashboard/latest-rush-notes?limit=${limit}`,
    );

    return response.data?.result;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const getEditorCaseActions = async (interval: any): Promise<any> => {
  try {
    const response = await DashboardAPI.get<ApiResponse<any>>(
      `/api/editor/dashboard/case-actions?interval=${interval}`,
    );

    return response.data?.result;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const getAppointmentEditorSummary = async (): Promise<
  AppointmentSummary[]
> => {
  try {
    const response = await DashboardAPI.get(
      "/api/editor/dashboard/appointments",
    );
    return response.data.result;
  } catch (error) {
    console.error("Error fetching appointment summary:", error);
    handleApiError(error);
    throw new Error(
      "Unable to fetch appointment summary. Please try again later.",
    );
  }
};

export const getEditorAppointmentAnalyticsView = async (): Promise<any> => {
  try {
    const response = await DashboardAPI.get<ApiResponse<any>>(
      `/api/editor/dashboard/appointments/analytics`,
    );

    return response.data?.result;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const getEditorWorkBreakDown = async (interval: any): Promise<any[]> => {
  try {
    const response = await DashboardAPI.get(
      `/api/editor/dashboard/workload-breakdown?interval=${interval}`,
    );
    return response.data?.result || [];
  } catch (error) {
    console.error("Error fetching case actions:", error);
    handleApiError(error);
    throw new Error("Unable to fetch case actions. Please try again later.");
  }
};

export const getEditorInvoiceOverview = async (
  interval: any,
): Promise<any[]> => {
  try {
    const response = await DashboardAPI.get(
      `/api/web/dashboard/historian/invoice-overview?interval=${interval}`,
    );
    return response.data?.result || [];
  } catch (error) {
    console.error("Error fetching case actions:", error);
    handleApiError(error);
    throw new Error("Unable to fetch case actions. Please try again later.");
  }
};

export const getEditorDoctorWise = async (
  limit: any,
  interval: any,
): Promise<any[]> => {
  try {
    const response = await DashboardAPI.get(
      `/api/editor/dashboard/doctorwise-status?topN=${limit}&interval=${interval}`,
    );
    return response.data?.result || [];
  } catch (error) {
    console.error("Error fetching case actions:", error);
    handleApiError(error);
    throw new Error("Unable to fetch case actions. Please try again later.");
  }
};
